import { getBootstrapData } from "../utils/market";

export const FaviconHandler = ({icon}) => {
    const head = document.getElementsByTagName('head')[0];
    const appleIcon = head.querySelector('[aria-roledescription="icon-apple"]');
    const largeIcon = head.querySelector('[aria-roledescription="icon-l"]');
    const smallIcon = head.querySelector('[aria-roledescription="icon-s"]');

    const { favicons } = getBootstrapData();

    if (favicons) {
        if (appleIcon) {
            appleIcon.href = icon || favicons.apple;
        }
        if (largeIcon) {
            largeIcon.href = icon || favicons.large;
        }
        if (smallIcon) {
            smallIcon.href = icon || favicons.small;
        }
    }

    return null;
}

